import React from 'react';
import ProgressByEmotions from './Graphs/ProgressByEmotions';

const HomeRightStats = () => {
    return (
        <div className="flex flex-col">
            <div className='mb-4'>
                <div className="w-full font-bold text-xl my-2"> Statistics </div>
                <div className='grid grid-cols-2 gap-4 my-4'>
                    <div className="bg-[#BAEAE2] rounded-2xl flex flex-col justify-between p-5">
                        <div className="w-full text-sm text-[#8EA3B7]">Average Response Time</div>
                        <div className='flex justify-between items-center mt-3'>
                            <div className='h-3/4 bg-[#2B2B21] w-1 rounded-xl'></div>
                            <div className='text-2xl text-[#2B2B21] font-bold'> 1:00 </div>
                        </div>
                    </div>
                    <div className="bg-[#BAEAE2] rounded-2xl flex flex-col justify-between p-5">
                        <div className="w-full text-sm text-[#8EA3B7]">Average Time Per Session</div>
                        <div className='flex justify-between items-center mt-3'>
                            <div className='h-3/4 bg-[#2B2B21] w-1 rounded-xl'></div>
                            <div className='text-2xl text-[#2B2B21] font-bold'> 30:00 </div>
                        </div>
                    </div>
                    <div className="bg-[#BAEAE2] rounded-2xl flex flex-col justify-between p-5">
                        <div className="w-full text-sm text-[#8EA3B7]">Correct Answers Per Session</div>
                        <div className='flex justify-between items-center mt-3'>
                            <div className='h-3/4 bg-[#2B2B21] w-1 rounded-xl'></div>
                            <div className='text-2xl text-[#2B2B21] font-bold'> 15 </div>
                        </div>
                    </div>
                    <div className="bg-[#BAEAE2] rounded-2xl flex flex-col justify-between p-5">
                        <div className="w-full text-sm text-[#8EA3B7]">Incorrect Answers Per Session</div>
                        <div className='flex justify-between items-center mt-3'>
                            <div className='h-3/4 bg-[#2B2B21] w-1 rounded-xl'></div>
                            <div className='text-2xl text-[#2B2B21] font-bold'> 05 </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-4'>
                <div className="w-full font-bold text-xl my-2"> Progress by Emotions </div>
                <ProgressByEmotions />
            </div>
        </div>
    );
};

export default HomeRightStats;
